import React from 'react'

import './UserViewInforPage.css'

const UserViewInforPage = () => {
   return <div>User View Infor Page</div>
}

export default UserViewInforPage
